module.exports = __webpack_public_path__ + "img/wuh.c65b7b95.png";